import { render } from "./cumplimiento.vue?vue&type=template&id=b71eb122&scoped=true"
import script from "./cumplimiento.vue?vue&type=script&lang=js"
export * from "./cumplimiento.vue?vue&type=script&lang=js"

import "./cumplimiento.vue?vue&type=style&index=0&id=b71eb122&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71eb122"]])

export default __exports__